export class Constants {

  // REGEX
  public static readonly REGEX_CODE = '[a-zA-Z0-9_.-]+';
  public static readonly REGEX_DECIMAL = '-?\\d+(\\.\\d+)?';
  public static readonly REGEX_INTEGER_POSITIVE = '\\d+';
  public static readonly REGEX_INTEGER_NEGATIVE_OR_POSITIVE = '-?\\d+';
  public static readonly REGEX_ALL_EXCEPT_SPACES = '\\S+';
  public static readonly REGEX_ALL_EXCEPT_SPACES_AND_GENERIC_CURRENCY_SYMBOL = '[^¤]\\S[^¤]+';
  public static readonly REGEX_ALPHA_NUM = '\\w+';
  public static readonly REGEX_UUID = /^[a-fA-F0-9]{8}-[a-fA-F0-9]{4}-[a-fA-F0-9]{4}-[a-fA-F0-9]{4}-[a-fA-F0-9]{12}$/;

  // KEY TYPES
  public static readonly KEY_PREFIX_ERROR = 'error.';
  public static readonly KEY_PREFIX_MSG = 'msg.';
  public static readonly KEY_PREFIX_LABEL = 'label.';

  public static readonly ERROR_ADMIN = Constants.KEY_PREFIX_ERROR + 'admin.';
  public static readonly ERROR_COMMON = Constants.KEY_PREFIX_ERROR + 'common.';
  public static readonly ERROR_USER = Constants.KEY_PREFIX_ERROR + 'user.';

  public static readonly LABEL_ADMIN = Constants.KEY_PREFIX_LABEL + 'admin.';
  public static readonly LABEL_COMMON = Constants.KEY_PREFIX_LABEL + 'common.';
  public static readonly LABEL_USER = Constants.KEY_PREFIX_LABEL + 'user.';

  public static readonly MSG_ADMIN = Constants.KEY_PREFIX_MSG + 'admin.';
  public static readonly MSG_COMMON = Constants.KEY_PREFIX_MSG + 'common.';
  public static readonly MSG_USER = Constants.KEY_PREFIX_MSG + 'user.';

  public static readonly USER_ME = 'me';

  /** Value of page attribut of PagedRequest to get all result without any pagination */
  public static readonly ALL_PAGE = -1;

  public static readonly USER_RESULT_CURRENT_RAWMATERIAL_ID = '00000000-0000-0000-0000-000000000000';
  public static readonly USER_RESULT_CURRENT_RAWMATERIAL_LABEL = 'label.user.rawmaterials.result.raw-material.current';

  public static readonly ARRAY_NB_ROW_BY_PAGE = [10, 25, 50, 100];
  public static readonly DEFAULT_NB_ROW_BY_PAGE = 25;
  public static readonly USER_META_NB_ROW_BY_PAGE = 'nb-row-by-page';
  public static readonly USER_META_NB_TABLE_RESULT = 'nb-table-result';
  public static readonly USER_META_RESULT_SHOW_UNIT = 'result-show-unit';
  public static readonly USER_META_RESULT_TOLERANCE_PERCENT = 'result-tolerance-percent';

  public static readonly DEFAULT_LANG = 'en';

  // check for Internet Explorer
  public static readonly IS_INTERNET_EXPLORER = /msie\s|trident\//i.test(window.navigator.userAgent);

  public static readonly JOB_TYPE_CALCULATE_BATCH = 'calculate_batch';
  public static readonly JOB_TYPE_IMPORT_RM_FULL_AUTO = 'import_rm_full_auto';
  public static readonly JOB_TYPE_MULTI_SAVE = 'rawMaterial_multi_save';

  // Raw materials form
  public static readonly MAX_LENGTH_FOR_RM_CODE = 50;
  public static readonly MAX_LENGTH_FOR_RM_LABEL = 255;
}
